import ko from 'knockout';
import WidgetObserver from 'managers/widgetObserver';

ko.bindingHandlers.widgetsContainer = {
    init: function (element, valueAccessor) {
        const observer = new WidgetObserver(element);

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => observer.dispose());
    }
};